import React from "react";

import { useCompetitionsTr } from "./useCompetitionsTr";
import { canonicalPromotion } from "./competitionsZones";

// Zone legend under standings/group tables — UI-SPEC §7: swatch 3×14px + label
// 12.5px #475569, gap 22, wraps. Every entry runs through the canonical zone
// mapper (competitionsZones.js): the spec's five zones get the spec palette
// and EN labels, anything else keeps the provider's name+color verbatim — the
// component never invents a zone. Labels run through the static bundle so
// K10's German wording ("Abstieg", "Relegation") applies.
//
// Entries without a colour or name are dropped; an empty list renders nothing.
export const dedupePromotions = (promotions) => {
  const seen = new Map();
  (promotions || []).forEach((raw) => {
    const p = canonicalPromotion(raw);
    if (!p || !p.color || !p.name) return;
    const key = p.id || `${p.name}|${p.color}`;
    if (!seen.has(key)) seen.set(key, p);
  });
  return Array.from(seen.values());
};

// Derive the legend from the rows actually displayed when no explicit
// promotions list is passed (same fallback idea as the home widget's legend).
export const promotionsFromRows = (rows) =>
  dedupePromotions((rows || []).map((r) => r && r.promotion).filter(Boolean));

const ZoneLegend = ({ promotions, swatchHeight = 14, fontSize = 12.5 }) => {
  const { tr } = useCompetitionsTr();
  const items = dedupePromotions(promotions);
  if (items.length === 0) return null;
  return (
    <div
      className="tp-comp-zone-legend"
      style={{ display: "flex", flexWrap: "wrap", gap: 22, alignItems: "center" }}
    >
      {items.map((p) => (
        <span
          key={p.id || `${p.name}|${p.color}`}
          style={{ display: "inline-flex", alignItems: "center", gap: 8 }}
        >
          <span
            data-testid="zone-swatch"
            style={{
              width: 3,
              height: swatchHeight,
              background: p.color,
              flex: "none",
            }}
          />
          <span style={{ fontSize, color: "#475569" }}>{tr(p.name)}</span>
        </span>
      ))}
    </div>
  );
};

export default ZoneLegend;
